<svg role="img">
  <use [attr.xlink:href]="iconName"></use>
</svg>